
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import NavMenu from '../../../components/NavMenu';
import ModalAdd from '../../components/ModalAdd';
import { Card, Icon, Tooltip } from 'antd';
import Chart from "react-google-charts";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

export default function Dashboard(props) {

    const classes = useStyles();
    const { Meta } = Card;
    const onSubmit = (screen) => {
        props.history.push({
            pathname: screen,
            state: 'MI DATA de Login'
        })
    };
    return (
        <div className={classes.root}>
            {/* <NavMenu SelectedIndex={props.history.location.pathname} />
            <CssBaseline />
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={3}>
                            <Card
                                style={{ width: '100%', height: '100%' }}
                                cover={
                                    <img
                                        alt="example"
                                        src={require("../../../assets/cotimages.jpg")}
                                        style={{ width: ' 100%', height: '150px' }}
                                    />
                                }
                                actions={[
                                    <Tooltip placement="top" title={'Editar procedimiento'}>
                                        <Icon type="edit" key="edit" onClick={() => onSubmit(`/Course`)} />
                                    </Tooltip>,
                                    <Tooltip placement="top" title={'Buscar procedimiento'}>
                                        <Icon type="search" onClick={() => onSubmit(`/Course`)} />
                                    </Tooltip>,
                                ]}
                            >
                                <Meta
                                    title="Procedimientos"
                                    description="Existen 50 procedimientos activos"
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={3}>
                            <Card
                                style={{ width: '100%', height: '100%' }}
                                cover={
                                    <img
                                        alt="example"
                                        src={require("../../../assets/cotimagesev.jpg")}
                                        style={{ width: ' 100%', height: '150px' }}
                                    />
                                }
                                actions={[
                                    <Tooltip placement="top" title={'Editar Evaluación'}>
                                        <Icon type="edit" key="edit" onClick={() => onSubmit(`/EvaluationsScreen`)} />
                                    </Tooltip>,
                                    <Tooltip placement="top" title={'Buscar Evaluación'}>
                                        <Icon type="search" onClick={() => onSubmit(`/EvaluationsScreen`)} />
                                    </Tooltip>,
                                ]}
                            >
                                <Meta
                                    title="Evaluaciones"
                                    description="Existen 40 evaluaciones activas"
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={3}>
                            <Card
                                style={{ width: '100%', height: '100%' }}
                                cover={
                                    <img
                                        alt="example"
                                        src={require("../../../assets/cotimageswc.jpg")}
                                        style={{ width: ' 100%', height: '150px' }}
                                    />
                                }
                                actions={[
                                    <Tooltip placement="top" title={'Editar CT'}>
                                        <Icon type="edit" key="edit" onClick={() => onSubmit(`/WorkCycle`)} />
                                    </Tooltip>,
                                    <Tooltip placement="top" title={'Buscar CT'}>
                                        <Icon type="search" onClick={() => onSubmit(`/WorkCycle`)} />
                                    </Tooltip>,
                                ]}
                            >
                                <Meta
                                    title="Ciclos de Trabajo"
                                    description="Existen 30 ciclos de trabajo activos"
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={3}>
                            <Card
                                style={{ width: '100%', height: '100%' }}
                                cover={
                                    <img
                                        alt="example"
                                        src={require("../../../assets/cotimagesdf.jpg")}
                                        style={{ width: ' 100%', height: '150px' }}
                                    />
                                }
                                actions={[
                                    <Tooltip placement="top" title={'Editar programa de comunicación'}>
                                        <Icon type="edit" key="edit" onClick={() => onSubmit(`/CommunicationProgramScreen`)} />
                                    </Tooltip>,
                                    <Tooltip placement="top" title={'Buscar programa de comunicación'}>
                                        <Icon type="search" onClick={() => onSubmit(`/CommunicationProgramScreen`)} />
                                    </Tooltip>,
                                ]}
                            >
                                <Meta
                                    title="Programas de comunicación"
                                    description="Existen 20 programas de comunicación"
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card
                                style={{ width: '100%' }}>
                                <Chart
                                    width={'100%'}
                                    height={'300px'}
                                    chartType="BarChart"
                                    loader={<div>Loading Chart</div>}
                                    data={[
                                        ['Cursos', 'Aprobado', 'Pendiente', 'Comunicado'],
                                        ['Curso 1', 500, 1500, 2000],
                                        ['Curso 2', 1500, 1500, 2000],
                                        ['Curso 3', 2000, 500, 1000],
                                    ]}
                                    options={{
                                        title: 'ERapids Cursos',
                                        chartArea: { width: '50%' },
                                        isStacked: true,
                                        hAxis: {
                                            title: 'Total de realización',
                                            minValue: 0,
                                        },
                                        vAxis: {
                                            title: 'Cursos',
                                        },
                                    }}
                                    // For tests
                                    rootProps={{ 'data-testid': '3' }}
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            </main> */}
        </div>
    );
}